import { Button, ButtonGroup, DialogBody, DialogFooter, DialogHeader } from "@wg/wows-react-uikit"
import StepCSSTransitionGroup from "@wg/wows-react-uikit/StepCSSTransitionGroup"
import moment from "moment"
import React, { PureComponent } from "react"
import { Interpolate } from "react-i18next"
import Slider from "react-slick"
import "slick-carousel/slick/slick.scss"
import { t, x } from "../../../helpers/localization"
import { IClanInfo, ICommonInfo, IHistoryRound, IWarSettings } from "../../../Reducers/ReducerClanWars"
import styles from "./ClanWarsHistory.scss"
import Round from "./Round"

const SLIDER_CHANGE_SPEED = 250

const NextArrow = (props: any) => {
  return <div className={`slick-next ${styles.nextArrow} ${props.disabled ? styles.disabled : ''}`} onClick={props.onClick} />
}

const PrevArrow = (props: any) => {
  return <div className={`slick-prev ${styles.prevArrow} ${props.disabled ? styles.disabled : ''}`} onClick={props.onClick} />
}

export interface ClanWarsHistory_IProps {
  roundsHistory: Array<IHistoryRound>
  roundsHistoryCount: number
  roundsHistoryOffset: number
  isRoundsHistoryLoading: boolean
  clanInfo: IClanInfo
  commonInfo: ICommonInfo
  warSettings: IWarSettings
  currentAccount: any
  roundsHistoryLimit: number
  id: string

  hideHistoryModal: () => void
  loadHistory: (limit: number, offset: number) => void
  refreshHistoryModal: () => void
}

export interface ClanWarsHistory_IState {
  activeSlide: number
}

class ClanWarsHistory extends PureComponent<ClanWarsHistory_IProps, ClanWarsHistory_IState> {

  state: ClanWarsHistory_IState = {
    activeSlide: 0
  }

  slider = null
  lastSlideChangeTimestamp = Date.now()

  UNSAFE_componentWillReceiveProps(nextProps: ClanWarsHistory_IProps) {
    const isGettingPrevious = this.props.roundsHistoryOffset > nextProps.roundsHistoryOffset
    const activeSlide = isGettingPrevious ? 0 : nextProps.roundsHistory.length - 1
    if (this.props.isRoundsHistoryLoading && nextProps.roundsHistory.length > 0) {
      this.setState({ activeSlide })
    }
  }

  showPrev = () => {
    const now = Date.now()
    const canChange = now - this.lastSlideChangeTimestamp > SLIDER_CHANGE_SPEED * 3
    if (this.slider && canChange) {
      this.lastSlideChangeTimestamp = now
      if (this.state.activeSlide === 0) {
        this.props.loadHistory(10, this.props.roundsHistoryOffset + this.props.roundsHistory.length)
      } else {
        this.slider.slickPrev()
      }
    }
  }

  showNext = () => {
    const now = Date.now()
    const canChange = now - this.lastSlideChangeTimestamp > SLIDER_CHANGE_SPEED * 3
    if (this.slider && canChange) {
      this.lastSlideChangeTimestamp = now
      if (this.state.activeSlide === this.props.roundsHistory.length - 1) {
        this.props.loadHistory(10, Math.max(this.props.roundsHistoryOffset - this.props.roundsHistoryLimit, 0))
      } else {
        this.slider.slickNext()
      }
    }
  }

  afterChange = (index: number) => {
    this.setState({
      activeSlide: index
    })
  }

  renderFooter = () => {
    return <DialogFooter>
      <ButtonGroup>
        <Button onClick={this.props.hideHistoryModal}>
          {t('Закрыть')}
        </Button>
      </ButtonGroup>
    </DialogFooter>
  }

  getStatusContent() {
    if (this.props.isRoundsHistoryLoading) {
      return <div className={styles.battlesNotFound}>{t('Идёт загрузка истории боёв')}</div>
    }

    if (!this.props.roundsHistory.length) {
      return <div className={styles.battlesNotFound}>{t('Ваш клан не участвовал ни в одном Морском Сражении')}</div>
    }

    return null
  }

  render() {
    const round = this.props.roundsHistory[this.state.activeSlide]
    const isEmptyBattlesHistory = !this.props.roundsHistory.length
    const previousDisabled = this.props.isRoundsHistoryLoading || (this.state.activeSlide === 0 && this.props.roundsHistoryOffset + this.props.roundsHistory.length === this.props.roundsHistoryCount)
    const nextDisabled = this.props.isRoundsHistoryLoading || this.state.activeSlide === this.props.roundsHistory.length - 1 + this.props.roundsHistoryOffset

    return <div className={styles.wrapper}>
      <DialogHeader>
        {round ? <Interpolate useDangerouslySetInnerHTML={true} i18nKey={x('Морское сражение: %(startDate)s - %(endDate)s')} number={round.number} startDate={moment(round.startDate).format('DD.MM.YY')} endDate={moment(round.endDate).format('DD.MM.YY')} parent={'span'} /> : t('История')}
      </DialogHeader>
      <StepCSSTransitionGroup level={2} id={this.props.id}>
        <DialogBody className={styles.sliderWrapper}>
          {this.getStatusContent() ? this.getStatusContent() : <Slider key={`Rounds${this.props.roundsHistory.length}${this.props.isRoundsHistoryLoading ? '_loading' : ''}`} className={styles.slider} ref={ref => {
            this.slider = ref
          }} dots={false} swipe={false} fade={false} arrows={false} initialSlide={this.state.activeSlide} infinite={false} focusOnSelect={false} speed={SLIDER_CHANGE_SPEED} afterChange={this.afterChange}>
            {this.props.roundsHistory.map((round, index) => {
              return <Round data={round} isVisible={index === this.state.activeSlide} key={`Round${index}`} clanInfo={this.props.clanInfo} commonInfo={this.props.commonInfo} warSettings={this.props.warSettings} currentAccount={this.props.currentAccount} />
            })}
          </Slider>}
        </DialogBody>
      </StepCSSTransitionGroup>
      {this.renderFooter()}

      {!isEmptyBattlesHistory && <PrevArrow onClick={this.showPrev} disabled={previousDisabled} />}
      {!isEmptyBattlesHistory && <NextArrow onClick={this.showNext} disabled={nextDisabled} />}
    </div>
  }
}

export default ClanWarsHistory